import React, { useEffect } from 'react';
import { onAuthStateChanged } from "firebase/auth";
import {  signOut } from "firebase/auth";
import { auth } from '../firebase';
import { useNavigate } from 'react-router-dom';
 
const HomePage = () => {
    const navigate = useNavigate();

    const handleLogout = () => {               
      signOut(auth).then(() => {
      // Sign-out successful.
          navigate("/");
          console.log("Signed out successfully")
      }).catch((error) => {
      // An error happened.
      });
    }

    useEffect(()=>{
        onAuthStateChanged(auth, (user) => {
            if (user) {
              // User is signed in, see docs for a list of available properties
              // https://firebase.google.com/docs/reference/js/firebase.User
              const uid = user.uid;
              // ...
              console.log("uid", uid)
            } else {
              // User is signed out
              // ...
              navigate("/login");
              console.log("user is logged out")
            }
          });
         
    }, [navigate])
 
    return(
      <>
          <nav>
          <h1 className="text-3xl font-bold underline text-slate-500">
              Hello world!
          </h1>

              <div>
            <button onClick={handleLogout}>
                      Logout
                  </button>
          </div>
          </nav>
      </>
  )
}
 
export default HomePage
